export function getGridElementsWithIssuesRequiringAttentionText(
  attentionRequiringGridElementsCount: number,
  attentionRequiringIssuesCount: number
): string {
  const objectWord = getElementWordBy(attentionRequiringGridElementsCount);

  return `${attentionRequiringIssuesCount} issues across ${attentionRequiringGridElementsCount} unique grid ${objectWord}`;
}
function getElementWordBy(attentionRequiringGridElementsCount: number) {
  return attentionRequiringGridElementsCount > 1 ? 'elements' : 'element';
}
